export enum E_DisplayMode {
  KioskBox = "kiosk-box",
  KioskSection = "kiosk-section",
  KioskHibridBox = "kiosk-hibrid-box",
  KioskHibridSection = "kiosk-hibrid-section",
  Default = "default",
}